import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/_authed/parent/balances')({
  beforeLoad: () => {
    throw redirect({ to: '/parent/notifications', replace: true });
  },
});
